(function () {
  'use strict';

  angular.module('tf.retailer.Util')
      .factory('Filter', FilterClass);

  function FilterClass(translateFilter) {

    return {
      getFilterSummaryText: getFilterSummaryText
    };


    function getFilterSummaryText(dashboard, params){
      var volumeText = '';
      volumeText += translateFilter('reports.'+ dashboard +'.summaryText', params);
      volumeText += params.region && params.region.length ? translateFilter('reports.'+ dashboard +'.selected.region',
          {'region': (params.region === 'All'? translateFilter('reports.allRegions') : params.region)}) : '';
      volumeText += params.timeFrame && params.timeFrame.length ? translateFilter('reports.'+ dashboard +'.selected.timeFrame',
          {'timeFrame': params.timeFrame.toLowerCase()}) : '';
      return _.unescape(volumeText);
    }
  }


})();